import {Component, ElementRef, inject, Input, OnInit, ViewChild} from '@angular/core';
import {NewsletterService} from '../../../services/newsletter.service';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {
    prepareAndDownloadFileAction,
    getFilenameFromHeaders,
    getMessageFromError
} from '../../../utils/other/utilities';
import {DialogService} from '../../../services/dialog.service';
import {KeycloakWrapperService} from '../../../utils/keycloak/keycloak-wrapper.service';
import {BehaviorSubject} from 'rxjs';

@Component({
    selector: 'app-newsletter',
    templateUrl: './newsletter.component.html',
    styleUrls: ['./newsletter.component.scss'],
    standalone: false
})
export class NewsletterComponent implements OnInit {

    @ViewChild('newsletterPopup', {static: true}) newsletterPopup: ElementRef;

    private readonly newsletterService = inject(NewsletterService);
    private readonly modalService = inject(NgbModal);
    private readonly dialogService = inject(DialogService);
    private readonly _kcService = inject(KeycloakWrapperService);

    @Input()
    isRead: BehaviorSubject<boolean>;

    private currentModal?: NgbModalRef;

    public ngOnInit(): void {
        this.isRead.subscribe((val) => {
            if (!val) {
                this.currentModal = this.modalService.open(this.newsletterPopup,
                    {
                        backdrop: 'static',
                        centered: true,
                        keyboard: true,
                        container: '#newsPopup'
                    });
            }
        });
    }

    public downloadNewsletterFile(event): void {
        event.preventDefault();
        this.newsletterService.getNewsletterFile().subscribe({
            next: (response) =>
                prepareAndDownloadFileAction(response.body, getFilenameFromHeaders(response.headers), 'application/pdf'),
            error: (error) => this.showErrorFromPossibleBlob(error)
        });
    }

    public setNewsletterRead(): void {
        this.newsletterService.setNewsletterRead(this.userEmail).subscribe({
            next: () => this.currentModal.close(),
            error: (error) => this.showError(error)
        });
    }

    private showErrorFromPossibleBlob(error: any) {
        const errPromise: Promise<string> = (error.error as Blob).text();
        if (errPromise) {
            errPromise.then((finalTxt) => this.showError(finalTxt));
        } else {
            this.showError(error);
        }
    }

    private showError(error: any): void {
        const dialogContent = this.dialogService.getNewDialogContent(
            'error',
            null,
            null,
            `ERROR.${getMessageFromError(error)}`
        );
        this.dialogService.openInfoDialog(dialogContent);
    }

    public get userEmail(): string {
        return this._kcService.getKeycloakInstance().profile.email;
    }
}
